import React, {FormEvent, useRef} from 'react';
import Spinner from "components/Spinner";
import {SearchIcon} from "@heroicons/react/outline";

type Props = {
    wait: number
    isSearching: boolean
    onChange: (searchTerm: string) => any
}

function SearchBar({wait, isSearching, onChange}: Props) {
    const timeout = useRef<ReturnType<typeof setTimeout>|null>(null);

    const handleSearch = (event: FormEvent<HTMLInputElement>): void => {
        const searchTerm = event.currentTarget.value

        if(timeout.current) clearTimeout(timeout.current)

        timeout.current = setTimeout(() => onChange(searchTerm), wait)
    }

    return (
        <div className="relative mt-1 rounded-md shadow-sm">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                {isSearching?
                    <Spinner color={Spinner.colors.BRAND} size={Spinner.sizes.X_SMALL} /> :
                    <SearchIcon className="h-5 w-5 text-gray-400" />}
            </div>
            <input type="search"
                   name="search"
                   id="search"
                   className="block w-full rounded-md border-gray-300 pl-10 focus:border-brand focus:ring-brand sm:text-sm"
                   placeholder="Search..."
                   onChange={handleSearch}
            />
        </div>
    );
}

SearchBar.defaultProps = {
    wait: 300,
    isSearching: false,
    onChange: () => null
}

export default SearchBar;